import { useCallback } from 'react';
import { Dropdown, Avatar } from 'antd';
import LanguageDropdown from './LanguageDropdown';
import LogoutImage from '../../assets/images/logout-red-icon.svg';
import { useTranslation } from 'react-i18next';
import { AppstoreAddOutlined, SwapOutlined } from '@ant-design/icons';
import { useBatchId } from '../../hooks/useBatchId';
import { ROOT, SELECT_MODULE } from '../../shared/Routes';
import ChevronDown from '../../assets/images/black-chevron-down.png';
import Icon from '../ui-components/Icon';
import { ProfileMenu, ProfileMenuItem } from './ProfileMenu';

interface WebAppHeaderProps {
	logout?: () => void | Promise<void>;
	username?: string;
	profileImage?: string;
	showHome?: boolean;
	showSwitchRole?: boolean;
}

export const WebHeader = ({
	logout,
	username,
	profileImage,
	showHome,
	showSwitchRole,
}: WebAppHeaderProps) => {
	const { t } = useTranslation();
	const handleLogoutClick = useCallback(() => {
		if (logout) {
			void logout();
		}
	}, [logout]);
	const { navigateToRoute } = useBatchId();
	const logoutText = t('logout');
	const selectModule = t('selectModule');
	const switchRole = t('switchRole');
	const LogoutIcon = () => (
		<>
			<img src={LogoutImage} alt="Logout Icon" />
		</>
	);

	const handleSwitchRoleClick = useCallback(() => {
		navigateToRoute(ROOT);
	}, [navigateToRoute]);

	const handleHomeClick = useCallback(() => {
		sessionStorage.removeItem('SELECTED_BATCH');
		navigateToRoute(SELECT_MODULE);
	}, [navigateToRoute]);

	const profileMenuItems: ProfileMenuItem[] = [
		{
			key: 'switch-role',
			label: switchRole,
			icon: <SwapOutlined />,
			onClick: handleSwitchRoleClick,
			visible: showSwitchRole,
		},
		{
			key: 'home',
			label: selectModule,
			icon: <AppstoreAddOutlined />,
			onClick: handleHomeClick,
			visible: showHome,
		},
		{
			key: 'logout',
			label: logoutText,
			icon: <LogoutIcon />,
			onClick: handleLogoutClick,
			variant: 'danger',
		},
	];

	return (
		<div className="hidden md:flex items-center justify-between px-4 space-x-6">
			{/* Language Dropdown */}
			<LanguageDropdown className="w-28 text-center" />

			{/* Profile Dropdown */}
			<Dropdown
				dropdownRender={() => <ProfileMenu items={profileMenuItems} />}
				trigger={['click']}
				placement="bottomRight"
			>
				<div className="flex items-center gap-x-1 cursor-pointer select-none">
					<Avatar
						src={profileImage}
						size={36}
						className="border border-gray-300"
					/>
					<span className="font-sans font-medium text-gray-700 text-sm">
						{username}
					</span>
					<Icon src={ChevronDown} width={16} height={16} />
				</div>
			</Dropdown>
		</div>
	);
};
